// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { default as _flatpickr } from 'flatpickr';
import Locale from 'flatpickr/dist/l10n/de';
import 'flatpickr/dist/flatpickr.css';

import { getCurrentLanguage } from 'cadenza/utils/i18n/i18n';

import type { Instance } from 'flatpickr/dist/types/instance';
import type { Options } from 'flatpickr/dist/types/options';
import type { key as LocaleKey, CustomLocale } from 'flatpickr/dist/types/locale';

import './flatpickr.css';

export {
  Instance as FlatpickrInstance,
  Options as FlatpickrOptions
};

// eslint-disable-next-line import/no-default-export -- This module is meant as a drop-in replacement for the flatpickr package itself.
export default function flatpickr (input: Element, config: Options = {}) {
  return _flatpickr(input, {
    time_24hr: true,
    minuteIncrement: 1,
    ...config,
    locale: { ...Locale[getCurrentLanguage() as LocaleKey], ...(config.locale as CustomLocale ?? {}) }
  });
}
